import React from "react";

const MAP = {
  Draft: { en: "Draft", hi: "प्रारूप", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  Submitted: { en: "Submitted", hi: "जमा किया गया", cls: "bg-blue-50 text-blue-700 border-blue-300" },
  "More Information Required": { en: "More Info Required", hi: "अधिक जानकारी आवश्यक", cls: "bg-amber-50 text-amber-800 border-amber-400" },
  "Under Review": { en: "Under Review", hi: "समीक्षाधीन", cls: "bg-indigo-50 text-indigo-700 border-indigo-300" },
  Verified: { en: "Verified", hi: "सत्यापित", cls: "bg-emerald-50 text-emerald-700 border-emerald-400" },
  Waitlisted: { en: "Waitlisted", hi: "प्रतीक्षा सूची", cls: "bg-orange-50 text-orange-700 border-orange-300" },
  Declined: { en: "Declined", hi: "अस्वीकृत", cls: "bg-red-50 text-red-700 border-red-300" },
};

export default function StatusBadge({ status, lang = "en" }) {
  const s = MAP[status] || MAP.Draft;
  return (
    <span
      data-testid={`status-badge-${status?.replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${s.cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {s[lang] || s.en}
    </span>
  );
}
